import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  get_all_public_event_links_data_action,
  get_jobs_hiring_manager_action,
  get_mentor_public_profile_data_action,
  invite_user_to_job_action,
  user_meta_data_action,
} from "../../../redux/_actions";
import { showSuccessMessage, showWarningMessage } from "../../../_uiComponents/ShowMessageSnack";
import { appRoutes } from "../../../_routes/app-routes";

function useMentorPublicProfile(props) {
  const [loading, setLoading] = useState(false);
  const [mentorData, setMentorData] = useState({});
  const [publicEvents, setPublicEvents] = useState({});
  const [userPrimarySkills, setUserPrimarySkills] = useState([]);
  const [inviteToJobLoading, setInviteToJobLoading] = useState(false);
  const [inviteToJobModal, setInviteToJobModal] = useState(false);
  const [allConnectedJobs, setAllConnectedJobs] = useState({});

  const { userMetaData } = useSelector((state) => state.user_meta_data_reducer);
  const { mentorPublicProfileData } = useSelector(
    (state) => state.get_mentor_public_profile_data_reducer
  );
  const { allConnectedJobsData } = useSelector(
    (state) => state.get_all_connected_jobs_reducer
  );

  const { publicEventLinksData } = useSelector(
    (state) => state.get_all_public_event_links_data_reducer
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    let id = params?.id;
    if (id) {
      getMentorInfo(id);
      getPublicEvents(id);
    }
  }, []);

  useEffect(() => {
    getUserMetaData();
  }, []);
  useEffect(() => {
    if (allConnectedJobsData?.data) {
      setAllConnectedJobs(allConnectedJobsData?.data);
    }
  }, [allConnectedJobsData]);
  useEffect(() => {
    if (mentorPublicProfileData?.data) {
      setMentorData(mentorPublicProfileData?.data);
      getUserPrimarySkills(mentorPublicProfileData?.data);
    }
  }, [mentorPublicProfileData]);

  useEffect(() => {
    if (publicEventLinksData?.data) {
      let results = publicEventLinksData?.data;
      if (results && results.length > 0) {
        let data = results[0];
        setPublicEvents(data);
      }
    }
  }, [publicEventLinksData]);

  // call initial apis
  const getUserMetaData = async () => {
    await dispatch(user_meta_data_action());
  };

  const getMentorInfo = async (id) => {
    setLoading(true);
    await dispatch(get_mentor_public_profile_data_action(id));
    setLoading(false);
  };
  const getPublicEvents = async (id) => {
    await dispatch(get_all_public_event_links_data_action(id));
  };
  const getUserPrimarySkills = (data) => {
    let skills = data?.skills;

    let results = skills && skills.filter((item) => item?.is_primary === true);

    if (results.length > 0) setUserPrimarySkills(results);
    else setUserPrimarySkills(skills);
  };

  const onInviteToJobClick = async (id) => {
    setInviteToJobLoading(true);
    if (userMetaData?.role === "hiring_manager") {
      await dispatch(get_jobs_hiring_manager_action());
    }
    setInviteToJobLoading(false);
    setInviteToJobModal(true);
  };

  const onJobInviteApplyClick = async (id) => {
    if (id) {
      let data = {
        invitee: mentorData?.user_details && mentorData.user_details?.id,
        job_posting: id,
        invite_role: "mentor",
      };

      await dispatch(invite_user_to_job_action(data));
    }
    setInviteToJobModal(false);
  };

  const onScheduleInterviewClick = async (id) => {
    if (publicEvents?.event_details) {
      navigate(
        `/schedule-interview?event_link=${
          publicEvents?.event_details && publicEvents.event_details?.hash_id
        }`
      );
    } else
      showWarningMessage("Mentor does not have a public event to schedule.");
  };

  const onNavigateBack = () => navigate(-1);

  const onInviteToJobModalClose = () => {
    setInviteToJobModal(false);
  };

  const onShareProfileClick = () => {
    const isDev =
      !process.env.NODE_ENV || process.env.NODE_ENV === "development";
    const url = isDev
      ? `http://localhost:3000${appRoutes.assessementKit.mentorProfile}${
          mentorData?.user_details &&
          mentorData.user_details?.hash_id
        }`
      : `${process.env.REACT_APP_DEV_ROOT_URL}${appRoutes.assessementKit.mentorProfile}${
          mentorData?.user_details &&
          mentorData.user_details?.hash_id
        }`;
    window.navigator.clipboard.writeText(url);

    showSuccessMessage(`Url copied ${url}`);
  };
  return {
    mentorData,
    loading,
    userPrimarySkills,
    userMetaData,
    inviteToJobLoading,
    allConnectedJobs,
    inviteToJobModal,
    onInviteToJobClick,
    onJobInviteApplyClick,
    onInviteToJobModalClose,
    onScheduleInterviewClick,
    onNavigateBack,
    onShareProfileClick
  };
}
export default useMentorPublicProfile;
